import {
    PersonalPermission,
    PublicRolePermissionInfo,
    Role,
    RolePermission,
} from '../../../../../common/types/user-info';

export enum PublicPermissionOverride {
    SUMMARIZATION = 'summarization',
}

export type RolePermissionMatrixSlice = Partial<Record<RolePermission, boolean>>;

export type RolePermissionMatrix = Partial<Record<Role, RolePermissionMatrixSlice>>;

export { Role, RolePermission, PersonalPermission };
export type { PublicRolePermissionInfo };
